import React from "react";
import CCR_Logo from '../../assets/images/CCR_Climate_Logo.png';
import { AppType } from "../../constant/appType";

function CCRCommonHeader(props) {

    const centerPage = () => {
        return (
            <div style={{ backgroundColor: 'white', borderRadius: '4px', margin: 'auto', width: '370px', padding: '0px 15px' }}>
                <div style={{ display: 'flex', padding: '8px 0px', alignItems: 'center', borderBottom: '2px solid #1CE783' }}>
                    <div style={{ padding: '10px 10px 0px' }}><img src={props.headerIcon} alt="header-icon" /></div>
                    <div style={{ fontSize: '22px', fontStyle: 'normal', fontWeight: '700', lineHeight: '125%', paddingTop: props.header === 'Account Creation' ? '8px' : '0px' }}> {props.header}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    {props.children}
                </div>
            </div>
        )
    }

    return (
        <>
            {AppType.CSS === props.appType
                ? <div style={{ paddingBottom: '95px' }}>
                    {centerPage()}
                </div>
                : <div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'right', alignItems: 'end', padding: '35px' }} >
                        <img src={CCR_Logo} alt="CCR_LOGO" />
                    </div>
                    <div style={{ marginTop: '6%' }}>
                        {centerPage()}
                    </div>
                </div>
            }
        </>
    );
}

export default CCRCommonHeader;